export default function (date) {
    if(!date)
      return null;
    const n = new Date(date);
    return `${n.getFullYear()}-${n.getMonth() + 1}-${n.getDate()}`;
  }
